import RatingStar from "./SVG/rating-star.svg?react";

const RatingStarIcon = () => {
  return <RatingStar />;
};

export default RatingStarIcon;
